import ToyotaDisplayRegularEot from 'common-tridium/fonts/toyota-display/ToyotaDisplay-Regular.eot';
import ToyotaDisplayRegularTtf from 'common-tridium/fonts/toyota-display/ToyotaDisplay-Regular.ttf';
import ToyotaDisplayRegularSvg from 'common-tridium/fonts/toyota-display/ToyotaDisplay-Regular.svg';
import ToyotaDisplayRegularWoff from 'common-tridium/fonts/toyota-display/ToyotaDisplay-Regular.woff';

import ToyotaTypeLight from 'common-tridium/fonts/toyota-type/ToyotaType-Light.ttf';
import ToyotaTypeLightItalics from 'common-tridium/fonts/toyota-type/ToyotaType-LightIt.ttf';
import ToyotaTypeBookEot from 'common-tridium/fonts/toyota-type/ToyotaType-Book.eot';
import ToyotaTypeBook from 'common-tridium/fonts/toyota-type/ToyotaType-Book.ttf';
import ToyotaTypeBookSvg from 'common-tridium/fonts/toyota-type/ToyotaType-Book.svg';
import ToyotaTypeBookWoff from 'common-tridium/fonts/toyota-type/ToyotaType-Book.woff';
import ToyotaTypeBookWoff2 from 'common-tridium/fonts/toyota-type/ToyotaType-Book.woff2';
import ToyotaTypeBookItalics from 'common-tridium/fonts/toyota-type/ToyotaType-BookIt.ttf';

import ToyotaTypeRegular from 'common-tridium/fonts/toyota-type/ToyotaType-Regular.ttf';
import ToyotaTypeRegularItalics from 'common-tridium/fonts/toyota-type/ToyotaType-RegularIt.ttf';

import ToyotaTypeSemiboldEot from 'common-tridium/fonts/toyota-type/ToyotaType-Semibold.eot';
import ToyotaTypeSemibold from 'common-tridium/fonts/toyota-type/ToyotaType-Semibold.ttf';
import ToyotaTypeSemiboldSvg from 'common-tridium/fonts/toyota-type/ToyotaType-Semibold.svg';
import ToyotaTypeSemiboldWoff from 'common-tridium/fonts/toyota-type/ToyotaType-Semibold.woff';
import ToyotaTypeSemiboldWoff2 from 'common-tridium/fonts/toyota-type/ToyotaType-Semibold.woff2';

import ToyotaTypeSemiBoldItalics from 'common-tridium/fonts/toyota-type/ToyotaType-SemiboldIt.ttf';

const toyotaDisplayRegular = {
  fontFamily: 'ToyotaDisplayRegular',
  fontStyle: 'normal',
  fontWeight: 400,
  src: [
    'local("ToyotaDisplay")',
    'local("ToyotaDisplay-Regular")',
    `url(${ToyotaDisplayRegularEot}) format('embedded-opentype')`,
    `url(${ToyotaDisplayRegularWoff}) format('woff')`,
    `url(${ToyotaDisplayRegularTtf}) format('truetype')`,
    `url(${ToyotaDisplayRegularSvg}) format('svg')`,
  ].join(', '),
};

const toyotaTypeLight = {
  fontFamily: 'ToyotaTypeLight',
  fontStyle: 'light',
  fontWeight: 200,
  src: ['local("ToyotaTypeLight")', 'local("ToyotaType-Light")', `url(${ToyotaTypeLight}) format('truetype')`].join(
    ', '
  ),
};

const toyotaTypeLightItalics = {
  fontFamily: 'ToyotaTypeLightItalics',
  fontStyle: 'italics',
  fontWeight: 200,
  src: [
    'local("ToyotaTypeLightItalics")',
    'local("ToyotaType-LightItalics")',
    `url(${ToyotaTypeLightItalics}) format('truetype')`,
  ].join(', '),
};

const toyotaTypeBook = {
  fontFamily: 'ToyotaTypeBook',
  fontStyle: 'normal',
  fontWeight: 400,
  src: [
    'local("ToyotaTypeBook")',
    'local("ToyotaType-Book")',
    `url(${ToyotaTypeBookEot}) format('embedded-opentype')`,
    `url(${ToyotaTypeBookWoff}) format('woff')`,
    `url(${ToyotaTypeBookWoff2}) format('woff2')`,
    `url(${ToyotaTypeBook}) format('truetype')`,
    `url(${ToyotaTypeBookSvg}) format('svg')`,
  ].join(', '),
};

const toyotaTypeBookItalics = {
  fontFamily: 'ToyotaTypeBookItalics',
  fontStyle: 'italics',
  fontWeight: 300,
  src: [
    'local("ToyotaTypeBookItalics")',
    'local("ToyotaType-BookItalics")',
    `url(${ToyotaTypeBookItalics}) format('truetype')`,
  ].join(', '),
};

export const toyotaTypeRegular = {
  fontFamily: 'ToyotaTypeRegular',
  fontStyle: 'normal',
  fontWeight: 400,
  src: [
    'local("ToyotaTypeRegular")',
    'local("ToyotaType-Regular")',
    `url(${ToyotaTypeRegular}) format('truetype')`,
  ].join(', '),
};

const toyotaTypeRegularItalics = {
  fontFamily: 'ToyotaTypeRegularItalics',
  fontStyle: 'italics',
  fontWeight: 400,
  src: [
    'local("ToyotaTypeRegularItalics")',
    'local("ToyotaType-RegularItalics")',
    `url(${ToyotaTypeRegularItalics}) format('truetype')`,
  ].join(', '),
};

const toyotaTypeSemibold = {
  fontFamily: 'ToyotaTypeSemibold',
  fontStyle: 'normal',
  fontWeight: 600,
  src: [
    'local("ToyotaTypeSemibold")',
    'local("ToyotaType-Semibold")',
    `url(${ToyotaTypeSemiboldEot}) format('embedded-opentype')`,
    `url(${ToyotaTypeSemiboldWoff}) format('woff')`,
    `url(${ToyotaTypeSemiboldWoff2}) format('woff2')`,
    `url(${ToyotaTypeSemibold}) format('truetype')`,
    `url(${ToyotaTypeSemiboldSvg}) format('svg')`,
  ].join(', '),
};

const toyotaTypeSemiBoldItalics = {
  fontFamily: 'ToyotaTypeSemiBoldItalics',
  fontStyle: 'italics',
  fontWeight: 600,
  src: [
    'local("ToyotaTypeSemiBoldItalics")',
    'local("ToyotaType-SemiBoldItalics")',
    `url(${ToyotaTypeSemiBoldItalics}) format('truetype')`,
  ].join(', '),
};

export const toyotaFontsFaces = [
  toyotaDisplayRegular,
  toyotaTypeLight,
  toyotaTypeLightItalics,
  toyotaTypeBook,
  toyotaTypeBookItalics,
  toyotaTypeRegular,
  toyotaTypeRegularItalics,
  toyotaTypeSemibold,
  toyotaTypeSemiBoldItalics,
];
